import { render, staticRenderFns } from "./ConfirmDeleteProductDetail.vue?vue&type=template&id=936eca0a&scoped=true&"
import script from "./ConfirmDeleteProductDetail.vue?vue&type=script&lang=js&"
export * from "./ConfirmDeleteProductDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "936eca0a",
  null
  
)

export default component.exports